<template>
	<svg class="icon" aria-hidden="true" @click="handleClick">
		<use :xlink:href="`#${name}`"></use>
	</svg>
</template>

<script>
	export default {
		name: 'symbol-icon',
		props: {
			name: '',
		},
		methods: {
			handleClick() {
				this.$emit('click');
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/common/SymbolIcon.vue